import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=c0ce6c70&scoped=true"
import script from "./back-button.ts?vue&type=script&lang=ts&external"
export * from "./back-button.ts?vue&type=script&lang=ts&external"
import style0 from "./back-button.scss?vue&type=style&index=0&id=c0ce6c70&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ce6c70",
  null
  
)

export default component.exports